import p from 'prop-types'
import React from 'react'

import { ArrowLink } from '../../../components'
import routes from '../../../router/routes'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function ProjectHeader({ title, baseline, locale, domain, label }) {
  return (
    <div className="container">
      <ArrowLink
        left
        className="project-link"
        route={routes.projects.path}
        routeParams={{
          locale,
          domain,
        }}
        label={title}
        icon="/images/icons/arrow-left-white.svg"
      />
      {/* <p className="title">{title}</p> */}
      <p className="baseline">{baseline}</p>
      <style jsx>{styles}</style>
    </div>
  )
}

ProjectHeader.propTypes = {
  title: p.string.isRequired,
  baseline: p.string.isRequired,
  domain: p.string.isRequired,
  locale: p.string.isRequired,
  label: p.string.isRequired,
}

ProjectHeader = chainDecorators(decorators, ProjectHeader)

export default ProjectHeader
